import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./Input.module.scss";
import InputFrame from "../InputFrame";

const Input = forwardRef(function Input(
  {
    error,
    requiredInput,
    withInfoIcon,
    labelPosition,
    errorMessage,
    disabled,
    label,
    className,
    type,
    multiline,
    placeholder,
    value,
    defaultValue,
    onChange,
    id,
    name,
    ...rest
  },
  ref
) {
  return (
    <InputFrame
      error={error}
      className={className}
      requiredInput={requiredInput}
      withInfoIcon={withInfoIcon}
      labelPosition={labelPosition}
      errorMessage={errorMessage}
      disabled={disabled}
      label={label}
    >
      {({ inputClassName }) => (
        <>
          {!multiline && (
            <input
              id={id}
              name={name}
              type={type}
              defaultValue={defaultValue}
              value={value}
              onChange={onChange}
              disabled={disabled}
              placeholder={placeholder}
              className={inputClassName}
              ref={ref}
              {...rest}
            />
          )}
          {multiline && (
            <textarea
              id={id}
              name={name}
              defaultValue={defaultValue}
              onChange={onChange}
              disabled={disabled}
              placeholder={placeholder}
              value={value}
              className={cx(inputClassName, styles.textarea)}
              ref={ref}
              {...rest}
            />
          )}
        </>
      )}
    </InputFrame>
  );
});

Input.displayName = "Input";

Input.defaultProps = {
  id: undefined,
  name: undefined,
  errorMessage: undefined,
  defaultValue: undefined,
  onChange: undefined,
  placeholder: undefined,
  withInfoIcon: false,
  multiline: false,
  disabled: false,
  requiredInput: false,
  className: null,
  type: "text",
  labelPosition: "top",
  value: undefined,
  error: false,
  label: null
};

Input.propTypes = {
  /** Input id */
  id: PropTypes.string,
  /** Input name */
  name: PropTypes.string,
  /** Change event callback */
  onChange: PropTypes.func,
  /** Input default value */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Input type */
  type: PropTypes.string,
  /** Input value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Input validation error message */
  errorMessage: PropTypes.string,
  /** Input placeHolder */
  placeholder: PropTypes.string,
  /** Add className to the component */
  className: PropTypes.string,
  /** Is input valid */
  error: PropTypes.bool,
  /** If provided, will add label before the input */
  label: PropTypes.string,
  /** If provided, will add information icon after the label */
  withInfoIcon: PropTypes.bool,
  /** Has multi lines */
  multiline: PropTypes.bool,
  /** Disabled state of input */
  disabled: PropTypes.bool,
  /** If provided, will add * after the label */
  requiredInput: PropTypes.bool,
  /** Available values are 'top' & 'left' */
  labelPosition: PropTypes.oneOf(["left", "top"])
};

export default Input;
